import React, { useState, useEffect } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  DownloadMultipleClientsDataInExcel,
  getEndOfMonth,
  getStartOfMonth,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import DragDrop from "../DragDrop/DragDrop";
function StatisticMenu() {
  const globalState = useGlobalState();
  const [isAnimation, setIsAnimation] = useState(false);

  const [moversList, setMoversList] = useState<any>([]);
  const [rateTypeData, setRateTypeData] = useState<any>([]);
  const [statisticMenuData, setStatisticMenu] = useState<any>([]);

  const [filterData, setFilterData] = useState({
    StartDate: new Date().getFullYear(),
    EndDate: new Date().getMonth() + 1,
    StartMonth: new Date().getMonth() + 1,
    MNVMoverID: 0,
    ShowJobData: true,
    ShowBonusAndDeductionsData: false,
    ShowReviewsData: false,
    IsFirstTime: true,
  });

  const [FilterObjectObject, setFilterObjectObject] = useState<any>({
    StartDate: getStartOfMonth(),
    EndDate: getEndOfMonth(),
  });

  useEffect(() => {
    getJobReviewGetJobDetailsAndMoversList(1);
    MNVMoverGetStatisticData();
  }, []);

  // useEffect(() => {
  //   if (filterData.MNVMoverID > 0 && filterData.IsFirstTime) {
  //     setFilterData((prevState: any) => ({
  //       ...prevState,
  //       IsFirstTime: false,
  //     }));
  //   }

  // }, [filterData]);

  function getJobReviewGetJobDetailsAndMoversList(typeid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.typeid = typeid;
    object.screenname = "employeebonusanddeductions";
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVJobReview/MNVJobReviewGetJobDetailsAndMoversList",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          if (typeid == 1) {
            setMoversList(l_oResponse[1]);
            // if (l_oResponse[1].length > 0 && AppContext.MNVMoverID == 0) {
            //   setFilterData((prevState: any) => ({
            //     ...prevState,
            //     MNVMoverID: l_oResponse[1][0]["MNVMoverID"],
            //   }));
            // } else {
            //   setFilterData((prevState: any) => ({
            //     ...prevState,
            //     MNVMoverID: AppContext.MNVMoverID,
            //   }));
            // }
          }
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function MNVMoverGetStatisticData() {
    setIsAnimation(true);
    let object = {} as any;
    object.mnvmoverid = filterData.MNVMoverID;
    object.startdate = moment(FilterObjectObject.StartDate).format(
      "YYYY-MM-DD",
    );
    object.enddate = moment(FilterObjectObject.EndDate).format("YYYY-MM-DD");
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVMoverJobData/MNVMoverGetStatisticData",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          console.log(l_oResponse);
          setStatisticMenu(l_oResponse);
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function getSelectedMNVMoverName() {
    let filtered = moversList.filter(
      (item: any) => item.MNVMoverID == filterData.MNVMoverID,
    );
    if (filtered.length > 0) return filtered[0].Name;
    else return "Statistic_Menu";
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <>
        <div className="flex-d justify-btw mb-10 m-f-wrap1">
          <div className="flex-da gap-10 m-f-wrap2">
            {AppContext.MNVMoverID == 0 && (
              <div className="field-input">
                <select
                  className="input-field width-auto"
                  value={filterData.MNVMoverID}
                  onChange={(e) => {
                    setFilterData((prevState: any) => ({
                      ...prevState,
                      MNVMoverID: e.target.value,
                    }));
                  }}
                >
                  <option value={0}>All</option>
                  {moversList &&
                    moversList.map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.MNVMoverID}>{item.Name}</option>
                      </React.Fragment>
                    ))}
                </select>
              </div>
            )}

            <div className="field-input grid-d flex-gap3 date-field">
              <span className="font-12 text-left label-color"></span>
              <input
                type="Date"
                className="input-field w-100"
                value={moment(FilterObjectObject.StartDate).format(
                  "YYYY-MM-DD",
                )}
                onChange={(e) => {
                  const selectedDate = moment(e.target.value);
                  setFilterObjectObject((prevState: any) => ({
                    ...prevState,
                    StartDate: selectedDate.format("YYYY-MM-DD"),
                  }));
                  setFilterData((prevState: any) => ({
                    ...prevState,
                    StartMonth: selectedDate.month() + 1,
                  }));
                }}
              />
            </div>
            <div className="field-input grid-d flex-gap3 date-field">
              <span className="font-12 text-left label-color"></span>
              <input
                type="Date"
                className="input-field w-100"
                value={moment(FilterObjectObject.EndDate).format("YYYY-MM-DD")}
                onChange={(e) => {
                  const selectedDate = moment(e.target.value);
                  setFilterObjectObject((prevState: any) => ({
                    ...prevState,
                    EndDate: selectedDate.format("YYYY-MM-DD"),
                  }));
                  setFilterData((prevState: any) => ({
                    ...prevState,
                    EndDate: selectedDate.month() + 1,
                  }));
                }}
              />
            </div>

            <div className="flex-daj btn-start">
              <a
                className="btn-primary flex-daj"
                onClick={() => MNVMoverGetStatisticData()}
              >
                Filter
              </a>
            </div>
          </div>
          <div className="flex-d gap-10 m-f-wrap3">
            <a
              className="btn-primary flex-daj btn-grid"
              title="Export All Tables"
              onClick={() =>
                DownloadMultipleClientsDataInExcel(
                  "Job_Data,Jobs_Ex_Sunday,Other_Stats",
                  getSelectedMNVMoverName() +
                    "_" +
                    AppContext.monthsList[filterData.StartMonth - 1].Name +
                    "-" +
                    AppContext.monthsList[filterData.EndDate - 1].Name +
                    "-" +
                    filterData.StartDate,
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>
        </div>

        <a
          className="accordion-top mt-10 flex-da justify-btw"
          onClick={() => {
            let filterDataLocal = filterData;
            filterDataLocal.ShowJobData = !filterDataLocal.ShowJobData;
            setFilterData((prevState: any) => ({
              ...prevState,
              ShowJobData: filterDataLocal.ShowJobData,
            }));
          }}
        >
          Jobs
          <img
            className={`name-count ${
              filterData.ShowJobData ? "rotate-90n" : "rotate-90"
            }`}
            src="/images/chev-right-w.svg"
            width={9}
            height={15}
          />
        </a>
        {/* {filterData.ShowJobData && ( */}
        <span className={filterData.ShowJobData ? "" : "no-display"}>
          <div className="flex-d justify-end mb-10 gap-10">
            <a
              className="btn-primary flex-daj btn-grid"
              title="Export"
              onClick={() =>
                DownloadMultipleClientsDataInExcel(
                  "Job_Data",
                  getSelectedMNVMoverName() +
                    "_" +
                    AppContext.monthsList[filterData.StartMonth - 1].Name +
                    "-" +
                    AppContext.monthsList[filterData.EndDate - 1].Name +
                    "-" +
                    filterData.StartDate,
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="Job_Data">
              <thead>
                <tr>
                  <th>Mover</th>
                  <th>Jobs</th>
                  <th>pre-boked hrs</th>
                  <th>additional hrs</th>
                  <th>days worked</th>
                  <th>average pre-booked job hours</th>
                  <th>average jobs per working day</th>
                  <th>average additional hours per job</th>
                </tr>
              </thead>
              <tbody>
                {statisticMenuData[0] &&
                  statisticMenuData[0].map((item: any, index: any) => (
                    <React.Fragment key={"emp" + index}>
                      <tr key={index}>
                        <td className="">{item.MNVMoverName}</td>
                        <td className="text-right">{item.TotalJobs}</td>
                        <td className="text-right">
                          {item.PreBookedHours?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td className="text-right">
                          {item.AdditionalHours?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td className="text-right">{item.DaysWorked}</td>
                        <td className="text-right">
                          {item.AveragePreBookedHours?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </td>
                        <td className="text-right">
                          {item.AverageJobsPerWorkingDay?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </td>
                        <td className="text-right">
                          {item.AverageAdditionalHours?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </span>
        {/* )} */}

        <a
          className="accordion-top mt-10 flex-da justify-btw"
          onClick={() => {
            let filterDataLocal = filterData;
            filterDataLocal.ShowBonusAndDeductionsData =
              !filterDataLocal.ShowBonusAndDeductionsData;
            setFilterData((prevState: any) => ({
              ...prevState,
              ShowBonusAndDeductionsData:
                filterDataLocal.ShowBonusAndDeductionsData,
            }));
          }}
        >
          Jobs (excluding Sunday)
          <img
            src="/images/chev-right-w.svg"
            className={`name-count ${
              filterData.ShowBonusAndDeductionsData ? "rotate-90n" : "rotate-90"
            }`}
            width={9}
            height={15}
          />
        </a>
        {/* {filterData.ShowBonusAndDeductionsData && ( */}
        <span
          className={filterData.ShowBonusAndDeductionsData ? "" : "no-display"}
        >
          <div className="flex-d justify-end mb-10 gap-10">
            <a
              className="btn-primary flex-daj btn-grid"
              title="Export"
              onClick={() =>
                DownloadMultipleClientsDataInExcel(
                  "Jobs_Ex_Sunday",
                  getSelectedMNVMoverName() +
                    "_" +
                    AppContext.monthsList[filterData.StartMonth - 1].Name +
                    "-" +
                    AppContext.monthsList[filterData.EndDate - 1].Name +
                    "-" +
                    filterData.StartDate,
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="Jobs_Ex_Sunday">
              <thead>
                <tr>
                  <th>Mover</th>
                  <th>Jobs</th>
                  <th>pre-boked hrs</th>
                  <th>additional hrs</th>
                  <th>days worked</th>
                  <th>Sundays worked (days)</th>
                  <th>average pre-booked job hours</th>
                  <th>average jobs per working day</th>
                  <th>average additional hours per job</th>
                </tr>
              </thead>
              <tbody>
                {statisticMenuData[1] &&
                  statisticMenuData[1].map((item: any, index: any) => (
                    <React.Fragment key={"emp" + index}>
                      <tr key={index}>
                        <td className="">{item.MNVMoverName}</td>
                        <td className="text-right">{item.TotalJobs}</td>
                        <td className="text-right">
                          {item.PreBookedHours?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td className="text-right">{item.AdditionalHours}</td>
                        <td className="text-right">
                          {item.DaysWorked?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td className="text-right">{item.SundaysWorked}</td>
                        <td className="text-right">
                          {item.AveragePreBookedHours?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </td>
                        <td className="text-right">
                          {item.AverageJobsPerWorkingDay?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </td>
                        <td className="text-right">
                          {item.AverageAdditionalHours?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </span>
        {/* )} */}

        <a
          className="accordion-top mt-10 flex-da justify-btw"
          onClick={() => {
            let filterDataLocal = filterData;
            filterDataLocal.ShowReviewsData = !filterDataLocal.ShowReviewsData;
            setFilterData((prevState: any) => ({
              ...prevState,
              ShowReviewsData: filterDataLocal.ShowReviewsData,
            }));
          }}
        >
          Other stats
          <img
            src="/images/chev-right-w.svg"
            className={`name-count ${
              filterData.ShowReviewsData ? "rotate-90n" : "rotate-90"
            }`}
            width={9}
            height={15}
          />
        </a>
        {/* {filterData.ShowReviewsData && ( */}
        <span className={filterData.ShowReviewsData ? "" : "no-display"}>
          <div className="flex-d justify-end mb-10 gap-10">
            <a
              className="btn-primary flex-daj btn-grid"
              title="Export"
              onClick={() =>
                DownloadMultipleClientsDataInExcel(
                  "Other_Stats",
                  getSelectedMNVMoverName() +
                    "_" +
                    AppContext.monthsList[filterData.StartMonth - 1].Name +
                    "-" +
                    AppContext.monthsList[filterData.EndDate - 1].Name +
                    "-" +
                    filterData.StartDate,
                )
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="Other_Stats">
              <thead>
                <tr>
                  <th>Mover</th>
                  <th>Jobs</th>
                  <th>Mattress covers sold</th>
                  <th>stairs climbed</th>
                  <th>average stairs per job</th>
                  <th>reviews</th>
                  <th>reviews %</th>
                  <th>social media</th>
                  <th>social media %,</th>
                  <th>claims involved</th>
                  <th>claims involved %</th>
                </tr>
              </thead>
              <tbody>
                {statisticMenuData[2] &&
                  statisticMenuData[2].map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      <tr key={index}>
                        <td className="">{item.MNVMoverName}</td>
                        <td className="text-right">
                          {item.TotalJobs}
                        </td>
                        <td className="text-right">
                          {item.MattressCoversSold}
                        </td>
                        <td className="text-right">{item.StairsClimbed}</td>
                        <td className="text-right">
                          {item.AverageStairsPerJob?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td className="text-right">{item.TotalReviews}</td>
                        <td className="text-right">
                          {item.ReviewsPercentage?.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                          %
                        </td>
                        <td className="text-right">{item.TotalSocialMedia}</td>
                        <td className="text-right">
                          {item.SocialMediaPercentage?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                          %
                        </td>
                        <td className="text-right">{item.TotalDamageClaims}</td>
                        <td className="text-right">
                          {item.DamageClaimsPercentage?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            },
                          )}
                          %
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>
        </span>
        {/* )} */}
      </>
    </div>
  );
}

export default StatisticMenu;
